import { render, staticRenderFns } from "./EdlTag.vue?vue&type=template&id=69fd2422&scoped=true&"
import script from "./EdlTag.vue?vue&type=script&lang=js&"
export * from "./EdlTag.vue?vue&type=script&lang=js&"
import style0 from "./EdlTag.vue?vue&type=style&index=0&id=69fd2422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fd2422",
  null
  
)

export default component.exports